export default {
  ADDRESSES: 'ADDRESSES',
  GENERAL_INFO: 'GENERAL_INFO',
  INVITATION: 'INVITATION',
  SEARCH: 'SEARCH',
  APPROVE: 'APPROVE',
  GOOGLE_RESULTS: 'GOOGLE_RESULTS'
};
